export default __webpack_public_path__ + "static/media/vendredi_sur_mer_2_lowdef.644280dc.png";